import React from "react";
import Story from "../../layouts/Story";
import Speed from "./charts/Speed";
import Infrastructure from "./charts/Infrastructure";
import Gaps from "./charts/Gaps";
import Affordability from "./charts/Affordability";
import Price from "./charts/Price";
const copy = require(`./copy/${process.env.REACT_APP_LANG}`);

const StoryFive = () => {
  const additionalComponents = {
    speed: (props) => <Speed {...props} countryMap={copy.countryMap} />,
    infrastructure: (props) => (
      <Infrastructure
        {...props}
        indicatorLabels={copy.indicatorLabels}
        indicatorDescriptions={copy.indicatorDescriptions}
      />
    ),
    gaps: (props) => (
      <Gaps
        {...props}
        indicatorLabels={copy.indicatorLabels}
        indicatorDescriptions={copy.indicatorDescriptions}
      />
    ),
    affordability: (props) => (
      <Affordability
        {...props}
        indicatorLabels={copy.indicatorLabels}
        indicatorDescriptions={copy.indicatorDescriptions}
      />
    ),
    price: (props) => <Price {...props} />,
  };

  return <Story {...copy} additionalComponents={additionalComponents} />;
};

export default StoryFive;
